export default {
  Title: 'Modification du \nmot de passe',
  EnterPassword: 'Nouveau mot de passe',
  ConfirmPassword: 'Confirmer le mot de passe',
  PasswordConfirmation: 'Le mot de passe et la confirmation ne sont pas identiques.',
  PasswordRequired: 'Champ obligatoire',
  PasswordConfirmationRequired: 'Champ obligatoire',
  PasswordSubmit: 'Enregistrer',
  PasswordCancel: 'Annuler',
  PasswordClear: 'Effacer',
  PasswordRetry: 'Réessayez',
  PasswordInfoMsg: 'Veuillez saisir le mot de passe que vous souhaitez utiliser pour accéder à votre compte.',
  PasswordStrength: 'Force du mot de passe : ',
  PasswordStrengthVeryStrong: 'TRÈS FORT',
  PasswordStrengthStrong: 'FORT',
  PasswordStrengthWeak: 'FAIBLE',
  Regle8CharMin: '8 caractères ou plus',
  Regle3Element: 'Au moins trois des quatre éléments suivants :',
  RegleLettreMinuscules: 'Lettres minuscules',
  RegleLettreMajuscules: 'Lettres majuscules',
  RegleChiffre: 'Chiffres',
  RegleCharSpec: 'Caractères spéciaux (@ % $ !)',
  PasswordError: 'Oups, une erreur s\'est produite. Voir plus bas.',
  expired: 'Votre session a expiré. Veuillez-vous connecter à nouveau.',
};
